import $ from 'jquery';
import Routing from 'routing';
import E1Request from '../classes/E1Request';
// eslint-disable-next-line import/no-cycle
import matrixInit from '../../plugins/e1-doc-matrix/e1matrixUI';
import Modal from '../classes/Modal';
import { triggerGeneratePackagesModal } from './packages';

export const updateTender = (id, data) => {
  if (parseInt(data.status, 10) === 2) {
    // Display a modal to capture additional information about awarded tenders
    const req = new E1Request(Routing.generate('app_tenderstage_updateawarded', { id }));
    req.show_loading_modal = true;
    req.submit();
  } else {
    const req = new E1Request(Routing.generate('app_tenderstage_update', { id }), 'POST', data);
    req.submit();
  }
};

/**
 * @return {boolean}
 */
export const matrixIsInReadOnlyMode = () => {
  const $gridContainer = $('#gridContainer');

  if ($gridContainer.length < 1) {
    throw new Error("Matrix grid container can't be found.");
  }

  return parseInt($gridContainer.attr('data-readonly'), 10) === 1;
};

export const fetchMatrixDetails = (generateIfEmpty, continueEditing, cb) => {
  const $gridContainer = $('#gridContainer');
  const stageId = parseInt($gridContainer.attr('data-stage'), 10);
  let addendumId = $gridContainer.attr('data-addendum');
  addendumId = addendumId === '' || typeof addendumId === 'undefined' ? null : addendumId;
  const readOnly = matrixIsInReadOnlyMode();
  const suppressWarning = parseInt($gridContainer.attr('data-suppress-warning'), 10);
  const stageType = parseInt($gridContainer.data('stage-type'), 10);

  const matrixRoute = Routing.generate('app_stagematrix_details', { id: stageId, addendumId });
  const matrixRequest = new E1Request(matrixRoute);

  matrixRequest.extraCallback = (response) => {
    if (!readOnly && addendumId === null && !suppressWarning) {
      const addendumWarningRoute = Routing.generate('app_stagematrix_pendingaddendummodal', {
        id: stageId,
      });

      const addendumWarningReq = new E1Request(addendumWarningRoute, 'GET', {});
      addendumWarningReq.show_loading_modal = false;
      addendumWarningReq.extraCallback = (resp) => {
        if (resp.close_modal_manually && $('.e1-modal.generate-packages-modal').length < 1) {
          Modal.closeAll();
        }
      };
      addendumWarningReq.submit();
    }

    if (generateIfEmpty) {
      // Loop over the packages, until we hit the first package that isn't a full set.
      let hasNoPackages = true;
      if (response.packages.length > 0) {
        let i = 0;
        while (hasNoPackages && i < response.packages.length) {
          if (!response.packages[i].fullSet) {
            hasNoPackages = false;
          }
          i += 1;
        }
      }

      if (hasNoPackages && !readOnly) {
        triggerGeneratePackagesModal(stageId);
      }
    }

    const options = {
      target: $gridContainer,
      stageId,
      stageType,
      packages: response.packages,
      documents: response.documents,
      continueEditing,
    };

    const matrixWrapper = matrixInit(options);

    if (typeof cb === 'function') {
      cb(matrixWrapper);
    }
  };

  matrixRequest.submit();
};
